module.exports = __webpack_public_path__ + "img/last_button_to_hem.1e810af2.png";